import { render, staticRenderFns } from "./TextareaList.vue?vue&type=template&id=6b00693f"
import script from "./TextareaList.vue?vue&type=script&lang=js"
export * from "./TextareaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports